import React from 'react';
import LotAndItemList from './LotAndItemList';

const LotAndItem = () => {
  return (
    <div className="card shadow-lg main-card" style={{ position: 'relative' }}>
      <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">{"Lot Summary"}</h4>
      </div>
      <div className="card-body">
        <LotAndItemList />
      </div>
    </div>
  );
};

export default LotAndItem;
